import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import PVOffering from "@/pages/PVOffering";

export const Route = createFileRoute("/es/servicios/farmacovigilancia/informes-seguridad")({
  head: () => buildRouteHead("/es/servicios/farmacovigilancia/informes-seguridad"),
  component: PVOffering,
});

